<template>
    <div class="fs-3">
        <!-- LOADER -->
        <preloader :display="loading" class="preloader prelative" />

        <!-- HEADER -->
        <header class="mb-5 billing-header mt--5 pt-0">
            <div class="round-64 relative dinlineb valign-middle primary-50-bkg">
                <i class="fab fa-sellsy absolute-center white" style="font-size: 26px"></i>
            </div>
            <div class="dinlineb valign-middle ml-3">
                <ul class="list-inline">
                    <li
                        v-for="(tab, tabIndex) in tabs"
                        :key="tabIndex"
                        class="mr-5"
                        :class="tab.active ? 'active' : ''"
                    >
                        <a
                            class="pointer"
                            :class="tab.permission == false ? 'link-disabled' : ''"
                            @click="tab.permission ? handleTab(tab) : null"
                            >{{ tab.label }}</a
                        >
                    </li>
                </ul>
            </div>
        </header>

        <!-- CONTENT -->
        <div class="container-small m-auto">
            <keep-alive>
                <component
                    :is="currentTab.component"
                    v-if="!loading"
                    :corporation="corporation"
                    @load="load"
                />
            </keep-alive>
        </div>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import SAMMixins from '../../../mixins/subscription/SAMMixins';
import PaymentMethods from './PaymentMethods.vue';
import InvoicingInformations from './InvoicingInformations.vue';

// NEW
import WidgetStore from '../../../mixins/sellsyaccountmanager/store/widgetStoreMixins';
import WidgetMixins from '../../../mixins/sellsyaccountmanager/widgetMixins';

export default {
    components: {
        PaymentMethods,
        InvoicingInformations,
        Preloader,
    },
    mixins: [
        SAMMixins,
        // NEW
        WidgetStore,
        WidgetMixins,
    ],
    props: {
        corporation: {
            type: Number,
            required: true,
        },
        isSellsy: {
            type: Boolean,
            required: false,
            default: () => false,
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
        };
    },
    computed: {
        currentTab() {
            return this.tabs.find((tab) => tab.active);
        },
    },
    created() {
        this.initCustomer();
        this.tabs = [
            {
                id: 'subscription',
                label: this.$l10n.__('Votre abonnement'),
                component: '',
                active: false,
                permission: false,
            },
            {
                id: 'invoices',
                label: this.$l10n.__('Vos factures'),
                component: '',
                active: false,
                permission: false,
            },
            {
                id: 'card',
                label: this.$l10n.__('Moyen de paiement'),
                component: 'payment-methods',
                active: true,
                permission: true,
            },
            {
                id: 'informations',
                label: this.$l10n.__('Informations de facturation'),
                component: 'invoicing-informations',
                active: false,
                permission: true,
            },
        ];
        const currentUrl = window.location.href;
        const tabRegExp = /#activetab=([A-Za-z]+)/;
        const matchActiveTab = currentUrl.match(tabRegExp);
        if (matchActiveTab !== null) {
            const activeTab = this.tabs.find((tab) => tab.id === matchActiveTab[1] && tab.permission);
            if (activeTab !== undefined) {
                this.setActiveTab(activeTab.id);
            }
        }
    },
    methods: {
        setActiveTab(id) {
            this.tabs.map((oneTab) => {
                oneTab.active = oneTab.id == id && oneTab.permission;
            });
        },
        handleTab(tab) {
            this.tabs.map((oneTab) => {
                oneTab.id == tab.id ? (oneTab.active = true) : (oneTab.active = false);
            });
        },
        initCustomer() {
            this.load(true);
            return Promise.all([
                this.getCustomerDatas(this.corporation),
                this.getActiveCreditCard(this.corporation),
            ])
                .then(([customer, creditCard]) => {
                    return Promise.all([
                        this.setCustomer(customer.data),
                        this.setBillingSettings(customer.billingSettings),
                        this.setBillingAddress(customer.billingAddress),
                        this.setCustomerSubscribedProducts(customer.subscribedProducts),
                        !creditCard.error ? this.setCustomerCreditCard(creditCard) : null,
                    ]);
                })
                .finally(() => this.load(false));
        },
        load(load) {
            this.loading = load;
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.billing-header {
    width: 80%;
    margin: auto;
    padding: 32px;
}
ul {
    li {
        position: relative;
        a {
            color: $gray-100;
        }
        &.active {
            a {
                color: $primary-50;
            }
            &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 30px;
                width: 100%;
                height: 2px;
                background-color: $primary-50;
                z-index: 2;
            }
        }
    }
}
</style>
